module.exports = __webpack_public_path__ + "img/kid_first-mobile.eb7df4cc.svg";